import React from 'react';

import GenderFilter from './GenderFilter';
import LocationFilter from './LocationFilter';

function Divider() {
  return <div className="mv8 bb b--default" />;
}

// TODO: eventually all of the filters will go in here
export default function SearchFilters() {
  return (
    <div className="SearchFilters ph4 pb15">
      <LocationFilter />
      <Divider />
      <GenderFilter />
    </div>
  );
}
